import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { I18nProvider } from "@/lib/i18n";
import { SiteContentProvider } from "@/lib/siteContent";
import ClinicLayout from "@/components/clinic/ClinicLayout";
import AuditLayout from "@/components/audit/AuditLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminPinGate from "@/components/AdminPinGate";
import Home from "@/pages/clinic/Home";
import Treatments from "@/pages/clinic/Treatments";
import TreatmentDetail from "@/pages/clinic/TreatmentDetail";
import About from "@/pages/clinic/About";
import Contact from "@/pages/clinic/Contact";
import Booking from "@/pages/clinic/Booking";
import Legal from "@/pages/clinic/Legal";
import Pqrs from "@/pages/clinic/Pqrs";
import Faq from "@/pages/clinic/Faq";
import Blog from "@/pages/clinic/Blog";
import BlogPost from "@/pages/clinic/BlogPost";
import MiCita from "@/pages/clinic/MiCita";
import PatientRegister from "@/pages/patient/PatientRegister";
import PatientLogin from "@/pages/patient/PatientLogin";
import PatientDashboard from "@/pages/patient/PatientDashboard";
import AuditList from "@/pages/audit/AuditList";
import AuditDetail from "@/pages/audit/AuditDetail";
import AuditLogin from "@/pages/audit/AuditLogin";
import AuditSignup from "@/pages/audit/AuditSignup";
import Admin from "@/pages/admin/Admin";
import "@/App.css";

export default function App() {
  return (
    <AuthProvider>
      <I18nProvider>
        <SiteContentProvider>
          <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route element={<ClinicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/tratamientos" element={<Treatments />} />
              <Route path="/tratamientos/:slug" element={<TreatmentDetail />} />
              <Route path="/sobre-nosotros" element={<About />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/reservar" element={<Booking />} />
              <Route path="/reservar/:slug" element={<Booking />} />
              <Route path="/faq" element={<Faq />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/mi-cita" element={<MiCita />} />
              <Route path="/paciente/registro" element={<PatientRegister />} />
              <Route path="/paciente/login" element={<PatientLogin />} />
              <Route path="/paciente/panel" element={<PatientDashboard />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/pqrs" element={<Pqrs />} />
            </Route>

            <Route path="/audit/login" element={<AuditLogin />} />
            <Route path="/audit/signup" element={<AuditSignup />} />
            <Route element={<ProtectedRoute><AuditLayout /></ProtectedRoute>}>
              <Route path="/audit" element={<AuditList />} />
              <Route path="/audit/:id" element={<AuditDetail />} />
            </Route>

            <Route path="/admin" element={<AdminPinGate><Admin /></AdminPinGate>} />
          </Routes>
        </BrowserRouter>
        </SiteContentProvider>
      </I18nProvider>
    </AuthProvider>
  );
}
